import { ActionsUnion, createAction } from '../helpers';

export enum EVisibilityUiActionType {
  SHOW_MAIN_LAYOUT = 'VISIBILITY/SHOW_MAIN_LAYOUT',
  HIDE_MAIN_LAYOUT = 'VISIBILITY/HIDE_MAIN_LAYOUT',
}

export const visibilityUiActions = {
  showMainLayout: () => createAction(EVisibilityUiActionType.SHOW_MAIN_LAYOUT),
  hideMainLayout: () => createAction(EVisibilityUiActionType.HIDE_MAIN_LAYOUT),
};

export type IVisibilityUiAction = ActionsUnion<typeof visibilityUiActions>;
